import wx from "weixin-js-sdk";
import { apiPost } from "@/api/api";
import { setWxTicket } from "@/utils/wxTicket";

export default {
  // 初始化SDK
  init(tenantNo, apiListParam, readyFunc) {
    let defaultApiList = [
      "hideOptionMenu",
      "showOptionMenu",
      "hideMenuItems",
      "showMenuItems",
      "openLocation",
      "hideAllNonBaseMenuItem",
      "showAllNonBaseMenuItem",
      "closeWindow",
      "getLocation",
      "updateAppMessageShareData",
      "updateTimelineShareData",
      "onMenuShareTimeline",
      "onMenuShareAppMessage",
      "onMenuShareQQ",
      "downloadFile"
    ];
    //添加 openLocation 权限
    if (apiListParam != null) {
      defaultApiList = defaultApiList.concat(apiListParam);
    }
    //通过后台接口返回所需参数
    apiPost("/open2/getJsSdkUiPackage", {
      tenantNo,
      url: window.location.href.split("#")[0]
    }).then(res => {
      if (res.data.code == 10000) {
        let myData = res.data.resultData.myData;
        let isSuccess = res.data.resultData.isSuccess;
        if (isSuccess) {
          wx.config({
            debug: false,
            appId: myData.appId, // 必填，公众号的唯一标识
            timestamp: myData.timestamp, // 必填，生成签名的时间戳
            nonceStr: myData.nonceStr, // 必填，生成签名的随机串
            signature: myData.signature, // 必填，签名
            jsApiList: defaultApiList // 必填，需要使用的JS接口列表
          });
          setWxTicket(myData.shareId);
        }
      }
    });
    wx.ready(typeof readyFunc == "function" ? readyFunc : new Function());
  }
};



// WEBPACK FOOTER //
// ./src/utils/wxUtils.js